export default (
  element,
  callback,
  options = false,
) => {
  const hasDuration = parseFloat(getComputedStyle(element).getPropertyValue('transition-duration') || '0') !== 0;

  if (hasDuration) {
    element.addEventListener('transitionend', (event) => {
      callback(event);
    }, options);
  } else {
    callback();
  }
};
